import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";

import moment from "moment";
import { toast } from "react-toastify";

const AtmosphereStorageForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "400px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});
  const [loading, setLoading] = useState(false);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const rangeRef = useRef({});
  const [rangeDetails, setRangeDetails] = useState([]);
  const [rangeClose, setRangeClose] = useState(false);

  const { sendRequest: postCas } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getStockLotForCAS } = useHttp();
  const [stock, setStock] = useState();

  useEffect(() => {
    getStockLotForCAS(
      {
        url: `/api/getStockLotForCAS/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (data) => {
        //console.log(data);
        setStock(data);
      }
    );
  }, [getStockLotForCAS]);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const submitHandler = (e) => {
    e.preventDefault();
    if (productDetails.length === 0) {
      toast.error("Product Details required");
      return;
    }
    setLoading(true);
    const data = {
      casDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      timeStamp: frmRef.current.time_stamp.value,
      chamberTemperature: frmRef.current.chamber_temp.value,
      remark: frmRef.current.remark.value,
      productDetail: productDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    //console.log(data);
    if (props.update) {
      data["casId"] = props.update.casId;
    }
    postCas(
      {
        url: "/api/ControlAtmosStorage/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Controlled Atmosphere Storage Data ${
            props.update ? "Updated" : "Added"
          }`
        );
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    //   //console.log(props.update);

    if (props.update) {
      // frmRef.current.date.value = moment(props.update.casDate).format(
      //   "YYYY-MM-DD"
      // );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);

      // frmRef.current.constant_monitoring.value =
      //   props.update.constantMonitoring;
      frmRef.current.chamber_temp.value = props.update.chamberTemperature;
      setRangeDetails(props.update.palletIdRange);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails && productDetails.length > 0
            ? productDetails &&
              productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemId: productRef.current.item_id.value,
        stockId: productRef.current.product_name.value,
        productName: productRef.current.pro_name.value,
        batchId: productRef.current.batch_id.value,
        quantity: productRef.current.quantity.value,
        temperature: productRef.current.temperature.value,
        obsvCount: productRef.current.obsv_count.value,
        o2: productRef.current.o2.value,
        co2: productRef.current.co2.value,
        sucrose: productRef.current.sucrose.value,
        reducingSugars: productRef.current.reducing_sugars.value,
        totalSugars: productRef.current.total_sugars.value,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        status: 1,
        createdDate: dateString,
        warehouseId: parseInt(localStorage.getItem("warehouseId")),
      },
    ]);

    //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitRange = (e) => {
    e.preventDefault();
    setRangeDetails((x) => [
      ...x,
      {
        itemIdFrom: rangeRef.current.item_id_from.value,
        itemIdTo: rangeRef.current.item_id_to.value,
        siItemId: rangeRef.current.si_item_id.value,
        excludedItemId: rangeRef.current.excluded_item_id.value,
      },
    ]);

    //console.log(rangeDetails);
  };

  const handleRangeDelete = (index, e) => {
    setRangeDetails(rangeDetails.filter((v, i) => i !== index));
  };

  const handleProductChange = (e) => {
    ////console.log(e.target.value);
    const id = e.target.value;
    const filterData = stock && stock.filter((item) => item.stockId == id);
    //console.log(filterData);

    productRef.current.item_id.value = filterData && filterData[0].itemId;
    productRef.current.batch_id.value = filterData && filterData[0].batch_no;
    productRef.current.quantity.value =
      filterData && filterData[0].productQuantityBal;
    productRef.current.pro_name.value = filterData && filterData[0].productName;
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    Controlled Atmosphere Storage Form
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update
                            ? props.update.casDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId == props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        defaultValue={getCurrentTime()}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"chamber_temp"}>
                        {"Chamber Temperature(°C)"}
                      </label>
                      <input
                        type={"number"}
                        id={"chamber_temp"}
                        required
                        ref={(el) => (frmRef.current["chamber_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave || x.itemId)
                            );
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"packed_item_id_range"}>
                        {"Pallet id Range"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"packed_item_id_range"}
                        autoComplete="off"
                        ref={(el) =>
                          (frmRef.current["packed_item_id_range"] = el)
                        }
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          rangeDetails &&
                            setRangeDetails((items) =>
                              items.filter((x) => x.isSave || x.siItemId)
                            );
                          setRangeClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2"></div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <h3 className="card-title">Item Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setClose(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"product_name"}>Product Name</label>
              <select
                id="product_name"
                className="form-control"
                ref={(el) => (productRef.current["product_name"] = el)}
                required
                onChange={handleProductChange}
              >
                <option>Select</option>
                {stock &&
                  stock.map((x) => (
                    <option value={x.stockId}>{x.productName}</option>
                  ))}
              </select>

              <input
                type={"input"}
                id={"itemId"}
                required
                ref={(el) => (productRef.current["pro_name"] = el)}
                className="form-control"
                hidden
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemId"}> Item Id</label>
              <input
                type={"input"}
                id={"itemId"}
                required
                ref={(el) => (productRef.current["item_id"] = el)}
                className="form-control"
                disabled
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"batch_id"}>Batch</label>
              <input
                type={"input"}
                id={"batch_id"}
                required
                ref={(el) => (productRef.current["batch_id"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"quantity"}>Quantity</label>
              <input
                type={"input"}
                id={"quantity"}
                required
                ref={(el) => (productRef.current["quantity"] = el)}
                className="form-control"
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"temperature"}>Temperature</label>
              <input
                type={"number"}
                id={"temperature"}
                required
                ref={(el) => (productRef.current["temperature"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"obsv_count"}>Obsv.Count</label>
              <input
                type={"number"}
                id={"obsv_count"}
                required
                ref={(el) => (productRef.current["obsv_count"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"o2"}>O2%</label>
              <input
                type={"number"}
                id={"o2"}
                required
                ref={(el) => (productRef.current["o2"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"co2"}>CO2%</label>
              <input
                type={"number"}
                id={"co2"}
                required
                ref={(el) => (productRef.current["co2"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"sucrose"}>Sucrose</label>
              <input
                type={"number"}
                id={"sucrose"}
                required
                ref={(el) => (productRef.current["sucrose"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"reducing_sugar"}>Reducing Sugars(RS)</label>
              <input
                type={"number"}
                id={"reducing_sugars"}
                required
                ref={(el) => (productRef.current["reducing_sugars"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"total_sugars"}>Total Sugars(TS)</label>
              <input
                type={"number"}
                id={"total_sugars"}
                required
                ref={(el) => (productRef.current["total_sugars"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <br />
              &nbsp;&nbsp;
              <button
                className="btn btn-sm btn-success"
                onClick={submitProduct}
              >
                +
              </button>
            </div>
          </div>

          <hr />

          <div className="">
            <table className="table table-sm table-bordered ">
              {" "}
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Product Name</th>
                  <th>Item Id</th>
                  <th>Batch</th>

                  <th>Quantity</th>

                  <th>Temperature</th>
                  <th>Obsv.Count</th>
                  <th>O2%</th>
                  <th>CO2%</th>
                  <th>Sucrose%</th>

                  <th>Reducing Sugars(RS)</th>
                  <th>Total Sugars(TS)</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.batchId}</td>

                        <td>{itm.quantity}</td>
                        <td>{itm.temperature}</td>
                        <td>{itm.obsvCount}</td>
                        <td>{itm.o2}</td>
                        <td>{itm.co2}</td>
                        <td>{itm.sucrose}</td>
                        <td>{itm.reducingSugars}</td>
                        <td>{itm.totalSugars}</td>

                        <td>
                          {" "}
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true) || x.casId > 0);
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      {rangeClose && (
        <Modal isOpen={true} style={modalStyles}>
          <h3 className="card-title">Pallet Id Range Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setRangeClose(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"item_id_from"}> Item id(from)</label>
              <input
                type={"input"}
                id={"item_id_from"}
                required
                ref={(el) => (rangeRef.current["item_id_from"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"item_id_to"}>Item id(to)</label>
              <input
                type={"input"}
                id={"item_id_to"}
                required
                ref={(el) => (rangeRef.current["item_id_to"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"si_item_id"}>Included Item id</label>
              <input
                type={"input"}
                id={"si_item_id"}
                required
                ref={(el) => (rangeRef.current["si_item_id"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"excluded_item_id"}>Excluded Item id </label>
              <input
                type={"input"}
                id={"excluded_item_id"}
                required
                ref={(el) => (rangeRef.current["excluded_item_id"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div>
            <br />
            <button className="btn btn-sm btn-success" onClick={submitRange}>
              +
            </button>
          </div>

          <hr />

          <table className="table table-sm table-bordered">
            {" "}
            <thead>
              <tr className="">
                <th>Item id (From)</th>
                <th>Item id(to)</th>
                <th>Separately Included Item id</th>
                <th>Item id Excluded </th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {rangeDetails &&
                rangeDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.itemIdFrom}</td>
                      <td>{itm.itemIdTo}</td>
                      <td>{itm.siItemId}</td>
                      <td>{itm.excludedItemId}</td>
                      <td>
                        <button
                          className="btn"
                          onClick={(e) => handleRangeDelete(i, e)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                rangeDetails.map((x) => (x["isSave"] = true));
                setRangeClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AtmosphereStorageForm;
